import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import PointOfSaleRoundedIcon from '@mui/icons-material/PointOfSaleRounded';
import Stack from '@mui/material/Stack/Stack';
import Typography from '@mui/material/Typography/Typography';

import PageTitle from '@/shared/components/layouts/PageTitle';
import Customer from '@/shared/types/customer.type';

type TitleProps = {
  assignedCustomer?: Customer;
  onFinalize: () => void;
  onCancelOrder: () => void;
};

const Title: FC<TitleProps> = ({
  assignedCustomer,
  onFinalize,
  onCancelOrder,
}) => {
  const { t } = useTranslation(['checkout', 'common']);

  return (
    <PageTitle
      title={t('common:checkout')}
      breadcrumbs={[
        {
          label: t('common:checkout'),
          icon: (
            <PointOfSaleRoundedIcon
              sx={{ width: 16, height: 16, color: 'text.secondary' }}
            />
          ),
        },
      ]}
      actions={[
        {
          label: t('checkout:cancelOrder'),
          icon: null,
          button: {
            size: 'large',
            variant: 'contained',
            color: 'error',
            onClick: onCancelOrder,
            sx: { gap: 1 },
          },
        },
        {
          label: t('checkout:finalize'),
          icon: null,
          button: {
            size: 'large',
            variant: 'contained',
            color: 'primary',
            onClick: onFinalize,
            sx: { gap: 1 },
          },
        },
      ]}
      customColumn={
        assignedCustomer && (
          <Stack alignItems='center'>
            <Typography
              variant='body1'
              sx={{
                textTransform: 'uppercase',
                fontWeight: 500,
                borderBottom: 1,
              }}
            >
              {assignedCustomer?.display_full_name}
            </Typography>
          </Stack>
        )
      }
    />
  );
};

export default Title;
